import {createSlice} from "@reduxjs/toolkit";

const initialState = {}

const slownikFormSelectedSlice = createSlice({
    name: 'slownikFormSelected',
    initialState,
    reducers: {
        setSlownikFormSelected: (state, action) => {
            state.name = action.payload.name
            state.data = action.payload.data
        },
    }
})

export const {setSlownikFormSelected} = slownikFormSelectedSlice.actions

export default slownikFormSelectedSlice.reducer